import { render, staticRenderFns } from "./backIssueBrowsing.vue?vue&type=template&id=7aaf1674&scoped=true"
import script from "./backIssueBrowsing.vue?vue&type=script&lang=js"
export * from "./backIssueBrowsing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaf1674",
  null
  
)

export default component.exports